import { createSlice } from "@reduxjs/toolkit";
import {
  activateDeactivateUser,
  CheckUserExistence,
  createUser,
  deleteUser,
  fetchBranches,
  fetchCountry,
  fetchGenders,
  fetchRoles,
  fetchUsers,
  fetchUsersTableColumnNames,
  resetUsers,
  updateUser,
  updateUserRole,
  activateDeleteUser
} from "./thunk";

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    roles: [],
    branches: [],
    genders: [],
    country: [],
    tableColumnNames: [],
    loading: false,
    Headerload: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Users Table Column Names API
      .addCase(fetchUsersTableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchUsersTableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchUsersTableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Users
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Branches
      .addCase(fetchBranches.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Get roles
      .addCase(fetchRoles.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        // state.loading = false;
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Add User API
      .addCase(createUser.pending, (state) => {
        state.error = null;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.users = [...action.payload.data, ...state.users];
      })
      .addCase(createUser.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateUser.pending, (state) => {
        state.error = null;
      });
    builder
      .addCase(updateUser.fulfilled, (state, action) => {
        const updatedUser = action.payload[0];
        const index = state.users.findIndex(
          (u) => u.ID === updatedUser.ID
        );

        if (index !== -1) {
          state.users[index] = updatedUser;
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(activateDeactivateUser.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateUser.fulfilled, (state, action) => {
        const { ID, IsActive } = action.payload;

        const user = state.users.find((u) => u.ID === ID);

        if (user) {
          user.IsActive = IsActive;
        }
      })
      .addCase(activateDeactivateUser.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteUser.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        // Extract IDs from the payload
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.users = state.users.filter(
          (item) => !deletedIds.includes(item.ID)
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(resetUsers.fulfilled, (state, action) => {
        
        state.users = action.payload;
        state.roles = action.payload;
      })

       // Check User API
      .addCase(CheckUserExistence.pending, (state) => {
        // This thunk is for field-specific UI feedback.
        // Avoid setting global loading/error states that might conflict.
        // e.g., state.checkingUserExistence = { [field]: true };
      })
      .addCase(CheckUserExistence.fulfilled, (state, action) => {
        // The result of this thunk is handled by the component for UI feedback.
        // No modification to global state.users or state.error is needed here.
      })
      .addCase(CheckUserExistence.rejected, (state, action) => {
        // The error is handled by the component.
        // No modification to global state.error is needed here to avoid conflicts.
      })

      // Update User Role
      .addCase(updateUserRole.pending, (state) => {
        state.error = null;
      })
      .addCase(updateUserRole.fulfilled, (state, action) => {
        const updatedUser = action.payload;
        // Filter out and remove the user from the list
        // state.users = state.users.filter((user) => user.ID !== updatedUser.ID);
        state.users = state.users.map((user) => user.ID == updatedUser.ID ? updatedUser : user)
      })
      .addCase(updateUserRole.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(activateDeleteUser.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeleteUser.fulfilled, (state, action) => {
        const activateUser = action.payload;
        state.users = state.users.map((user) => user.ID == activateUser.ID ? {...user, IsDelete: activateUser.IsDelete } : user)
      })
      .addCase(activateDeleteUser.rejected, (state, action) => {
        state.error = action.payload;
      })
  },
});

export default usersSlice.reducer;